import { Link } from '@material-ui/core';
import React from 'react';
import { TranslateCallback } from 'Utils';
import {
  ContactListItem, ContactListItemAction, SPPContactTypeLevelsEnum,
} from '../../../Types';
import { RetrieveRoleAreaPriorityLevel } from '../Utils';
import { updateContactTypes } from '../../../hooks/useContactQueries';
import { getContactTypeMapKey } from '../ContactTypes/utils';

function loadContact(tempMap:Map<string, ContactListItem>, assignedContactsMap:Map<string, ContactListItem>, service:string, roleArea:string, level:string) {
  const btContact = tempMap.get(getContactTypeMapKey(service, roleArea, level, 'bt'));
  if (btContact) assignedContactsMap.set(getContactTypeMapKey(service, roleArea, level), btContact);
  const stContact = tempMap.get(getContactTypeMapKey(service, roleArea, level, 'st'));
  if (stContact) assignedContactsMap.set(getContactTypeMapKey(service, roleArea, level), stContact);
}

async function assignContactEvent(additionalInfo: any, contact: ContactListItem) {
  const data:any = {
    data: [
      {
        contactId: contact.id,
        service: additionalInfo.service,
        roleArea: additionalInfo.roleArea,
        level: additionalInfo.level,
        action: 'add',
      },
    ],
  };

  return updateContactTypes(additionalInfo.location, data);
}

function createRenderComponent(customAction: ContactListItemAction, contact: ContactListItem): JSX.Element {
  const currentContactPriorityLevel: string | null = RetrieveRoleAreaPriorityLevel(contact, customAction.additionalInfo.service, customAction.additionalInfo.roleArea);
  const disableAssign: boolean = (currentContactPriorityLevel !== SPPContactTypeLevelsEnum.general && currentContactPriorityLevel !== null);

  if (disableAssign) return <span style={{ color: '#999', fontStyle: 'italic' }}>{customAction.label}</span>;

  return (
    <div
      style={{ cursor: 'pointer' }}
      onClick={async () => {
        await assignContactEvent(customAction.additionalInfo, contact);
        if (customAction.additionalInfo.callback) customAction.additionalInfo.callback(contact);
      }}
    >
      <Link><b>{customAction.label}</b></Link>
    </div>
  );
}

function getCustomActions(actionsParams: any, t:TranslateCallback):ContactListItemAction[] {
  const {
    service, roleArea, level, location, callback,
  } = actionsParams;
  const actionList: ContactListItemAction[] = [];
  actionList.push({
    id: level,
    label: t('Assign'),
    action: () => {},
    additionalInfo: {
      service,
      roleArea,
      level,
      location,
      callback,
    },
    renderElement: createRenderComponent,
  });
  return actionList;
}

async function remove(contact:ContactListItem, service:string, roleArea:string, level:string, location: string) {
  const data:any = {
    data: [
      {
        contactId: contact.id,
        service,
        roleArea,
        level,
        action: 'remove',
      },
    ],
  };

  return updateContactTypes(location, data);
}

export {
  loadContact,
  remove,
  getCustomActions,
};
